import React from 'react';
import { Rocket, Sparkles } from 'lucide-react';

export interface ComingSoonCardProps {
  workbookLabel?: string;
  title: string;
  instructions?: string;
  sourcePage?: number;
  message?: string;
}

export const ComingSoonCard: React.FC<ComingSoonCardProps> = ({
  workbookLabel,
  title,
  instructions,
  sourcePage,
  message = 'This activity type is under review.',
}) => {
  return (
    <div className="overflow-hidden rounded-[2rem] border-4 border-amber-300/90 bg-gradient-to-br from-amber-100 via-yellow-50 to-orange-100 shadow-xl dark:border-amber-800/60 dark:from-amber-950/50 dark:via-slate-900 dark:to-slate-900">
      <div className="relative px-6 py-10 text-center">
        <Sparkles className="absolute left-6 top-6 h-16 w-16 text-amber-400/40" aria-hidden />
        <Rocket className="absolute right-6 bottom-6 h-20 w-20 text-orange-400/40" aria-hidden />
        {workbookLabel ? (
          <p className="text-sm font-extrabold text-amber-800 tamil-text dark:text-amber-200" lang="ta">
            {workbookLabel}
          </p>
        ) : null}
        <h2 className="mt-2 text-2xl font-black text-amber-950 tamil-text md:text-3xl dark:text-amber-50" lang="ta">
          {title}
        </h2>
        {instructions ? (
          <p className="mt-3 text-lg font-semibold text-amber-900/90 tamil-text dark:text-amber-100/80" lang="ta">
            {instructions}
          </p>
        ) : null}
        {sourcePage != null ? (
          <span className="mt-4 inline-block rounded-full bg-amber-600 px-3 py-1 text-sm font-bold text-white">p.{sourcePage}</span>
        ) : null}
        <div className="mx-auto mt-8 max-w-md rounded-3xl border-4 border-white bg-white/90 p-6 text-lg font-bold text-amber-950 shadow-inner dark:border-slate-600 dark:bg-slate-800/90 dark:text-amber-50">
          {message}
        </div>
        <p className="mt-6 text-base font-semibold text-amber-800 tamil-text dark:text-amber-200" lang="ta">
          விரைவில் இங்கே விளையாட்டு வடிவில் வரும்!
        </p>
      </div>
    </div>
  );
};
